/**
 * Generated by orval 🍺
 * Do not edit manually.
 * STBportalen
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Monteringsanalys,
  SignResult,
  ValidationResult
} from '../../model';

import { customInstance } from '../../../mutator/custom-instance';
import type { ErrorType , BodyType } from '../../../mutator/custom-instance';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiMonteringsanalysProjectId = (
    projectId: number,
 signal?: AbortSignal
) => {


      return customInstance<Monteringsanalys>(
      {url: `/api/Monteringsanalys/${projectId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiMonteringsanalysProjectIdQueryKey = (projectId: number,) => {
    return [
    `/api/Monteringsanalys/${projectId}`
    ] as const;
    }


export const getGetApiMonteringsanalysProjectIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiMonteringsanalysProjectId>>, TError = ErrorType<unknown>>(projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiMonteringsanalysProjectId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiMonteringsanalysProjectIdQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiMonteringsanalysProjectId>>> = ({ signal }) => getApiMonteringsanalysProjectId(projectId, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiMonteringsanalysProjectId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiMonteringsanalysProjectIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiMonteringsanalysProjectId>>>
export type GetApiMonteringsanalysProjectIdQueryError = ErrorType<unknown>


export function useGetApiMonteringsanalysProjectId<TData = Awaited<ReturnType<typeof getApiMonteringsanalysProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiMonteringsanalysProjectId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMonteringsanalysProjectId>>,
          TError,
          Awaited<ReturnType<typeof getApiMonteringsanalysProjectId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiMonteringsanalysProjectId<TData = Awaited<ReturnType<typeof getApiMonteringsanalysProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiMonteringsanalysProjectId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMonteringsanalysProjectId>>,
          TError,
          Awaited<ReturnType<typeof getApiMonteringsanalysProjectId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiMonteringsanalysProjectId<TData = Awaited<ReturnType<typeof getApiMonteringsanalysProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiMonteringsanalysProjectId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiMonteringsanalysProjectId<TData = Awaited<ReturnType<typeof getApiMonteringsanalysProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiMonteringsanalysProjectId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiMonteringsanalysProjectIdQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putApiMonteringsanalys = (
    monteringsanalys?: BodyType<Monteringsanalys>,
 signal?: AbortSignal
) => {


      return customInstance<Monteringsanalys>(
      {url: `/api/Monteringsanalys`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: monteringsanalys, signal
    },
      );
    }




export const getPutApiMonteringsanalysMutationKey = () => ['putApiMonteringsanalys'] as const;

export const getPutApiMonteringsanalysMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiMonteringsanalys>>, TError,PutApiMonteringsanalysMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiMonteringsanalys>>, TError,PutApiMonteringsanalysMutationVariables, TContext> => {

const mutationKey = getPutApiMonteringsanalysMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiMonteringsanalys>>, PutApiMonteringsanalysMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  putApiMonteringsanalys(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiMonteringsanalysMutationResult = NonNullable<Awaited<ReturnType<typeof putApiMonteringsanalys>>>
    export type PutApiMonteringsanalysMutationBody = BodyType<Monteringsanalys> | undefined
    export type PutApiMonteringsanalysMutationError = ErrorType<unknown>
    export type PutApiMonteringsanalysMutationVariables = {data?: BodyType<Monteringsanalys>}

    export const usePutApiMonteringsanalys = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiMonteringsanalys>>, TError,PutApiMonteringsanalysMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiMonteringsanalys>>,
        TError,
        PutApiMonteringsanalysMutationVariables,
        TContext
      > => {
      return useMutation(getPutApiMonteringsanalysMutationOptions(options), queryClient);
    }
    export const getApiMonteringsanalysValidateProjectId = (
    projectId: number,
 signal?: AbortSignal
) => {


      return customInstance<ValidationResult>(
      {url: `/api/Monteringsanalys/validate/${projectId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiMonteringsanalysValidateProjectIdQueryKey = (projectId: number,) => {
    return [
    `/api/Monteringsanalys/validate/${projectId}`
    ] as const;
    }


export const getGetApiMonteringsanalysValidateProjectIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiMonteringsanalysValidateProjectId>>, TError = ErrorType<unknown>>(projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiMonteringsanalysValidateProjectId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiMonteringsanalysValidateProjectIdQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiMonteringsanalysValidateProjectId>>> = ({ signal }) => getApiMonteringsanalysValidateProjectId(projectId, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiMonteringsanalysValidateProjectId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiMonteringsanalysValidateProjectIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiMonteringsanalysValidateProjectId>>>
export type GetApiMonteringsanalysValidateProjectIdQueryError = ErrorType<unknown>


export function useGetApiMonteringsanalysValidateProjectId<TData = Awaited<ReturnType<typeof getApiMonteringsanalysValidateProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiMonteringsanalysValidateProjectId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMonteringsanalysValidateProjectId>>,
          TError,
          Awaited<ReturnType<typeof getApiMonteringsanalysValidateProjectId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiMonteringsanalysValidateProjectId<TData = Awaited<ReturnType<typeof getApiMonteringsanalysValidateProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiMonteringsanalysValidateProjectId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMonteringsanalysValidateProjectId>>,
          TError,
          Awaited<ReturnType<typeof getApiMonteringsanalysValidateProjectId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiMonteringsanalysValidateProjectId<TData = Awaited<ReturnType<typeof getApiMonteringsanalysValidateProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiMonteringsanalysValidateProjectId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiMonteringsanalysValidateProjectId<TData = Awaited<ReturnType<typeof getApiMonteringsanalysValidateProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiMonteringsanalysValidateProjectId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiMonteringsanalysValidateProjectIdQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiMonteringsanalysSignProjectId = (
    projectId: number,
 signal?: AbortSignal
) => {


      return customInstance<SignResult>(
      {url: `/api/Monteringsanalys/sign/${projectId}`, method: 'POST', signal
    },
      );
    }




export const getPostApiMonteringsanalysSignProjectIdMutationKey = () => ['postApiMonteringsanalysSignProjectId'] as const;

export const getPostApiMonteringsanalysSignProjectIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiMonteringsanalysSignProjectId>>, TError,PostApiMonteringsanalysSignProjectIdMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiMonteringsanalysSignProjectId>>, TError,PostApiMonteringsanalysSignProjectIdMutationVariables, TContext> => {

const mutationKey = getPostApiMonteringsanalysSignProjectIdMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiMonteringsanalysSignProjectId>>, PostApiMonteringsanalysSignProjectIdMutationVariables> = (props) => {
          const {projectId} = props ?? {};

          return  postApiMonteringsanalysSignProjectId(projectId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiMonteringsanalysSignProjectIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiMonteringsanalysSignProjectId>>>

    export type PostApiMonteringsanalysSignProjectIdMutationError = ErrorType<unknown>
    export type PostApiMonteringsanalysSignProjectIdMutationVariables = {projectId: number}

    export const usePostApiMonteringsanalysSignProjectId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiMonteringsanalysSignProjectId>>, TError,PostApiMonteringsanalysSignProjectIdMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiMonteringsanalysSignProjectId>>,
        TError,
        PostApiMonteringsanalysSignProjectIdMutationVariables,
        TContext
      > => {
      return useMutation(getPostApiMonteringsanalysSignProjectIdMutationOptions(options), queryClient);
    }
